import React from "react";
import { Container } from 'react-bootstrap';

import WOW from "wowjs";

class Hero extends React.Component {

	componentDidMount() {
    	new WOW.WOW().init();
  	}
  	render() {
		return (
			<div className="HereoBanner Consultingback">
			    <div className="Banner_Content">
					<Container fluid>
						<h2 className="wow fadeInUp">SERVICES</h2>
						<div className="red-border"> </div>
						<p>Wide breadth of software development, mobile app development, web development and IT consulting services across the entire IT spectrum.</p>
					</Container>
				</div>
			</div>
		);
	}
};

export default Hero;
